import { createFileRoute } from '@tanstack/react-router'
import { CustomerDetail } from '../../../pages/CustomerDetail'

export const Route = createFileRoute('/helpdesk/customers/$id')({
  component: CustomerDetail,
})